module.exports = __webpack_public_path__ + "img/tech_8.0d2d502b.png";